import NotAllowedPage from './NotAllowedPage.component';

export default NotAllowedPage;
